import { Component, inject, OnInit } from '@angular/core'
import {
  clearLatestPunchIn,
  createClockInClockOut,
  getLatestClockIn,
  loadEmployeeAttendance,
  updateClockIn
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.actions'
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import {
  selectClockInClockOutState,
  selectExpectedWorkHoursThisMonth,
  selectExpectedWorkHoursThisWeek,
  selectExpectedWorkHoursToday,
  selectIsPunchedIn,
  selectTodaysClockinoutRecords,
  selectTotalBreakHoursToday,
  selectTotalCount,
  selectTotalOvertimeThisMonth,
  selectTotalOvertimeToday,
  selectTotalProductiveWorkHoursToday,
  selectTotalWorkHoursThisMonth,
  selectTotalWorkHoursThisWeek,
  selectTotalWorkHoursToday
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.selectors'
import {
  BehaviorSubject,
  combineLatest,
  filter,
  interval,
  map,
  Observable,
  of,
  startWith,
  switchMap,
  take,
  tap
} from 'rxjs'
import { CommonModule } from '@angular/common'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import {
  ClockInClockOut,
  ClockInClockOutResponse
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.state'
import { selectUser } from '../../../../store/auth/auth.selectors'
import { AuthState, User } from '../../../../store/auth/auth.state'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import {
  NgxDaterangepickerBootstrapComponent,
  NgxDaterangepickerBootstrapDirective
} from 'ngx-daterangepicker-bootstrap'
import dayjs from 'dayjs'
import {
  selectClockinclockouts,
  selectLatestPunchIn
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.reducer'
import { loadBusinesses } from '../../../../store/business/business.actions'
import { LeaveType } from '../../leaves/applied-leaves/applied-leaves.component'
import { eps } from '../../../../services/url.service'
import { loadEmployeeById } from '../../../../store/user/user.actions'
import { selectEmployeeDetail } from '../../../../store/user/user.selectors'
import { WorkStatus } from '../../attendance/calander/calander.component'
import { SharedModule } from '../../../../shared/shared.module'
import { data } from 'jquery'

// export enum LeaveType {
//   LEAVEWITHOUTPAY = 'Leave Without Pay',
//   CASUAL = 'Casual Leave',
//   SICK = 'Sick Leave'
// }

export enum StatusType {
  APPROVED = 'Approved',
  CANCELLED = 'Cancelled',
  REJECTED = 'Rejected',
  PENDING = 'Pending'
}

interface DateRange {
  startDate: dayjs.Dayjs
  endDate: dayjs.Dayjs
}

declare var $: any

@Component({
  selector: 'app-attendance',
  imports: [
    CommonModule,
    RouterModule,
    // CapitalizePipe,
    PaginationComponent,
    NgbTooltipModule,
    NgxDaterangepickerBootstrapDirective,
    // NgxDaterangepickerBootstrapComponent,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements OnInit {
  private store = inject(Store) // Inject store using `inject()`

  isPunchedIn$: Observable<boolean> = this.store.select(selectIsPunchedIn)
  isPunchedIn = false
  punchInId = ''
  latestPunchIn$: Observable<ClockInClockOut | null> = this.store.pipe(select(selectLatestPunchIn))
  latestPunchIn!: ClockInClockOut | null
  user: AuthState['user'] | null = null
  currentPage = 1
  pageLimit = 10
  loading$: Observable<boolean> = this.store.select(state => state.appliedLeaves.loading)
  error$: Observable<string | null> = this.store.select(state => state.appliedLeaves.error)
  pageLastRecord = 0
  attendances$: Observable<ClockInClockOutResponse[]>
  totalCount = 0
  totalCount$ = this.store.select(selectTotalCount)
  search = ''
  leaveTypeEnum = LeaveType // Make the enum accessible in the template
  statusEnum = StatusType
  dateRange: DateRange = {
    startDate: dayjs(), // current date
    endDate: dayjs() // current date
  }
  leaveType = ''
  status = ''
  totalWorkHoursThisMonth = ''
  totalWorkHoursThisWeek = ''
  totalWorkHoursToday = ''
  todaysClockinoutRecords!: ClockInClockOut[]
  totalProductiveWorkHoursToday = ''
  totalBreakHoursToday = ''
  // totalWorkHoursThisMonth$!: Observable<string>
  // totalWorkHoursThisWeek$!: Observable<string>
  totalWorkHoursThisWeek$ = this.store.select(selectTotalWorkHoursThisWeek)
  totalWorkHoursThisMonth$ = this.store.select(selectTotalWorkHoursThisMonth)
  totalWorkHoursToday$ = this.store.select(selectTotalWorkHoursToday)
  todaysClockinoutRecords$ = this.store.select(selectTodaysClockinoutRecords)
  totalProductiveWorkHoursToday$ = this.store.select(selectTotalProductiveWorkHoursToday)
  totalBreakHoursToday$ = this.store.select(selectTotalBreakHoursToday)
  expectedWorkHoursToday$ = this.store.select(selectExpectedWorkHoursToday)
  expectedWorkHoursThisWeek$ = this.store.select(selectExpectedWorkHoursThisWeek)
  expectedWorkHoursThisMonth$ = this.store.select(selectExpectedWorkHoursThisMonth)
  totalOvertimeToday$ = this.store.select(selectTotalOvertimeToday)
  totalOvertimeThisMonth$ = this.store.select(selectTotalOvertimeThisMonth)
  timeLabels: string[] = []
  public progressData: { start: string; width: string; color: string }[] = []
  businessIdss!: string[]
  employeeId = ''
  public selectedAttendance: any = ''
  employee$: Observable<User | undefined> = of(undefined) // Initialize with a default value
  employeeData: any = ''
  workstatusEnum = WorkStatus
  progressRotation: string = 'rotate(-90deg)'
  attendancePercent = 0
  maxWorkHours = 9
  leftRotation = 'rotate(0deg)'
  rightRotation = 'rotate(0deg)'
  selectedStatus$ = new BehaviorSubject<string | null>(null)
  selectedDate: string = dayjs().format('YYYY-MM-DD')
  form!: FormGroup
  private initialDate: string = dayjs().format('YYYY-MM-DD')
  private pickerInitialized = false

  hiddenStatuses = new Set([
    this.workstatusEnum.LEAVECANCELLED,
    this.workstatusEnum.LEAVEREQUEST,
    this.workstatusEnum.LEAVEREJECTED,

    this.workstatusEnum.ATTENDANCEREGULARIZEREQUEST,
    this.workstatusEnum.ATTENDANCEREGULARIZEREQUESTCANCELLED,
    this.workstatusEnum.ATTENDANCEREGULARIZEREQUESTREJECTED,

    this.workstatusEnum.LEAVESECONDHALFAPPLIED,
    this.workstatusEnum.LEAVESECONDHALFREJECTED,
    this.workstatusEnum.LEAVESECONDHALFCANCELLED,

    this.workstatusEnum.LEAVEFIRSTHALFAPPLIED,
    this.workstatusEnum.LEAVEFIRSTHALFREJECTED,
    this.workstatusEnum.LEAVEFIRSTHALFCANCELLED,

    this.workstatusEnum.COMPOFFAPPLIED,
    this.workstatusEnum.COMPOFFREJECTED,
    this.workstatusEnum.COMPOFFCANCELLED,

    this.workstatusEnum.COMPOFFLEAVEAPPLIED,
    this.workstatusEnum.COMPOFFLEAVECANCELLED,
    this.workstatusEnum.COMPOFFLEAVEREJECTED,

    this.workstatusEnum.BREAK,
    this.workstatusEnum.REGULARIZEPRESENTHALF,
    this.workstatusEnum.COMPOFFEARNED,
    this.workstatusEnum.LEAVEFIRSTHALFCANCELREQUESTED,
    this.workstatusEnum.LEAVESECONDHALFCANCELREQUESTED
    // this.workstatusEnum.HOLIDAY,
    // this.workstatusEnum.WEEKLYOFF,
    // this.workstatusEnum.EARLY
  ])

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {
    this.employeeId = this.route.snapshot.paramMap.get('id')!
    const dateParam = this.route.snapshot.queryParamMap.get('date')
    // if (dateParam) {
    //   this.initialDate = dateParam
    // }
    this.initialDate =
      dateParam && dayjs(dateParam).isValid() ? dateParam : dayjs().format('YYYY-MM-DD')
    this.generateTimeLabels()
    // this.attendances$ = this.store.select(selectClockinclockouts)
    // this.attendances$ = this.store.select(selectClockinclockouts).pipe(
    //   map(data =>
    //     data.map(item => ({
    //       ...item,
    //       workStatus: item.workStatus?.includes('Leave') ? 'Leave' : item.workStatus,
    //       dayRecords: item.dayRecords?.map((dr: any) => ({
    //         ...dr,
    //         workStatus: dr.workStatus?.includes('Leave') ? 'Leave' : dr.workStatus
    //       }))
    //     }))
    //   )
    // )
    // this.attendances$.subscribe(data => console.log('attendances', data))

    // this.attendances$ = this.store.select(selectClockinclockouts).pipe(
    //   map(data =>
    //     data.flatMap(item =>
    //       (item.dayRecords || []).map((dr: any) => ({
    //         ...dr,
    //         date: dr.clockIn, // for display
    //         firstClockIn: dr.clockIn,
    //         lastClockOut: dr.clockOut,
    //         totalWorkHours: dr.workHour,
    //         workStatus: dr.workStatus?.includes('Leave') ? 'Leave' : dr.workStatus
    //       }))
    //     )
    //   )
    // )

    this.attendances$ = combineLatest([
      this.store.select(selectClockinclockouts),
      this.selectedStatus$
    ]).pipe(
      map(([data, selectedStatus]) => {
        const grouped = new Map<string, any>()
        data.forEach(item => {
          ;(item.dayRecords || []).forEach((dr: any) => {
            // if (
            //   dr.workStatus === this.workstatusEnum.LEAVECANCELLED ||
            //   dr.workStatus === this.workstatusEnum.LEAVEREQUEST ||
            //   dr.workStatus === this.workstatusEnum.LEAVEREJECTED ||
            //   dr.workStatus === this.workstatusEnum.BREAK ||
            //   dr.workStatus === this.workstatusEnum.HOLIDAY ||
            //   dr.workStatus === this.workstatusEnum.WEEKLYOFF ||
            //   dr.workStatus === this.workstatusEnum.LEAVESECONDHALFAPPLIED ||
            //   dr.workStatus === this.workstatusEnum.ATTENDANCEREGULARIZEREQUEST ||
            //   dr.workStatus === this.workstatusEnum.EARLY
            // ) {
            //   return
            // }
            if (this.hiddenStatuses.has(dr.workStatus)) {
              return
            }
            const date = dayjs(dr.clockIn).format('YYYY-MM-DD')

            if (!grouped.has(date)) {
              grouped.set(date, {
                date: dr.clockIn,
                firstClockIn: dr.clockIn,
                lastClockOut: dr.clockOut,
                lateLogin: dr.lateLogin,
                totalBreakHours: item.totalBreakHours || '0h 0m',
                overTime: item.overTime || '0h 0m',
                productiveHours: item.productiveHours || '0h 0m',
                totalWorkHours: '0h 0m',
                totalMinutes: 0,
                statuses: new Set<string>(),
                recordByStatus: {} as Record<string, any>,
                dayRecords: []
              })
            }

            const group = grouped.get(date)
            // const normalizedStatus = dr.workStatus?.includes('Leave')
            //   ? 'Leave'
            //   : dr.workStatus === 'ClockIn'
            //     ? 'Clock In/Out'
            //     : dr.workStatus
            // const normalizedStatus = dr.workStatus === this.workstatusEnum.CLOCKIN ? 'Clock In/Out' : dr.workStatus
            // const normalizedStatus =
            //   dr.workStatus === this.workstatusEnum.CLOCKIN ? 'Present' : dr.workStatus

            if (dr.workHour) {
              const match = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(dr.workHour)
              const hours = match ? parseInt(match[1] || '0', 10) : 0
              const minutes = match ? parseInt(match[2] || '0', 10) : 0
              group.totalMinutes += hours * 60 + minutes
            }

            let normalizedStatus = dr.workStatus
            if (dr.workStatus === this.workstatusEnum.CLOCKIN) {
              normalizedStatus = 'Present'
            } else if (dr.workStatus === this.workstatusEnum.WEEKLYOFF) {
              normalizedStatus = 'Weekly Off'
            } else if (dr.workStatus === this.workstatusEnum.HOLIDAY) {
              normalizedStatus = 'Holiday'
            } else if (dr.workStatus === this.workstatusEnum.EARLY) {
              normalizedStatus = 'Early'
            }

            // group.statuses.add(normalizedStatus)
            // group.recordByStatus[normalizedStatus] = dr
            group.dayRecords.push(dr)

            // if (dr.workStatus === this.workstatusEnum.CLOCKIN && dr.clockIn) {
            //   group.statuses.add('Present')
            // }

            if (dr.workStatus === this.workstatusEnum.CLOCKIN) {
              group.statuses.add('Present')
              group.recordByStatus['Present'] = dr
            } else if (dr.workStatus === this.workstatusEnum.LATE) {
              group.statuses.add('Present')
              group.statuses.add('Late')
              group.recordByStatus['Present'] = dr
              group.recordByStatus['Late'] = dr
            } else {
              // if (normalizedStatus === this.workstatusEnum.PRESENTHALF) {
              //   group.statuses.delete('Present')
              // }
              group.statuses.add(normalizedStatus)
              group.recordByStatus[normalizedStatus] = dr
            }

            if (dr.clockIn && dayjs(dr.clockIn).isBefore(group.firstClockIn)) {
              group.firstClockIn = dr.clockIn
            }
            if (
              dr.clockOut &&
              (!group.lastClockOut || dayjs(dr.clockOut).isAfter(group.lastClockOut))
            ) {
              group.lastClockOut = dr.clockOut
            }
            if (normalizedStatus === 'Late' && dr.lateLogin) {
              group.lateLogin = dr.lateLogin
            }
          })
        })

        return Array.from(grouped.values())
          .map(group => {
            const hours = Math.floor(group.totalMinutes / 60)
            const minutes = group.totalMinutes % 60
            group.totalWorkHours = `${hours}h ${minutes}m`
            // const allStatuses = Array.from(group.statuses) as string[]
            // if (!selectedStatus) {
            //   return {
            //     ...group,
            //     workStatus: allStatuses
            //   }
            // }
            const allStatuses = Array.from(group.statuses) as string[]

            const hasHalfDay =
              allStatuses.includes(this.workstatusEnum.PRESENTHALF) ||
              allStatuses.includes(this.workstatusEnum.REGULARIZEPRESENTHALF)

            const hasNonAbsentStatus = allStatuses.some(
              status => status !== this.workstatusEnum.ABSENT && status !== 'Absent'
            )

            const filteredStatuses = allStatuses.filter(status => {
              if (hasHalfDay && status === 'Present') {
                return false
              }

              if (
                hasNonAbsentStatus &&
                (status === this.workstatusEnum.ABSENT || status === 'Absent')
              ) {
                return false
              }

              return true
            })

            if (!selectedStatus) {
              return {
                ...group,
                workStatus: filteredStatuses
              }
            }
            const matchMap: Record<string, string> = {
              // Present: 'Clock In/Out',
              Present: 'Present',
              Late: 'Late',
              Leave: 'Leave',
              Absent: 'Absent',
              Early: 'Early',
              Holiday: 'Holiday',
              'Weekly Off': 'Weekly Off'
            }
            const targetStatus = matchMap[selectedStatus]
            const matchedRecord = group.recordByStatus[targetStatus]
            if (!matchedRecord) {
              return null
            }
            // return {
            //   ...group,
            //   workStatus: [targetStatus],
            //   firstClockIn: matchedRecord.clockIn,
            //   lastClockOut: matchedRecord.clockOut,
            //   lateLogin: matchedRecord.lateLogin || '0h 0m',
            //   totalBreakHours: matchedRecord.totalBreakHours || '0h 0m'
            // }

            // const displayStatus =
            //   selectedStatus === 'Present' ? 'Clock In/Out - Present' : targetStatus
            // const displayStatus =
            //   selectedStatus === 'Present' ? ['Clock In/Out', 'Present'] : targetStatus
            // const displayStatus = selectedStatus === 'Present' ? 'Present' : targetStatus

            const displayStatuses =
              selectedStatus === 'Late'
                ? ['Present', 'Late']
                : selectedStatus === 'Present'
                  ? ['Present']
                  : [targetStatus]

            return {
              ...group,
              // workStatus: selectedStatus === 'Present' ? [...displayStatus] : [displayStatus],
              // workStatus: [displayStatus],
              workStatus: displayStatuses,
              firstClockIn: matchedRecord.clockIn,
              lastClockOut: matchedRecord.clockOut,
              lateLogin: matchedRecord.lateLogin || '0h 0m',
              totalBreakHours: matchedRecord.totalBreakHours || '0h 0m'
            }
          })
          .filter(row => row !== null)
      })
    )

    // this.latestPunchIn$ = this.store.pipe(select(selectLatestPunchIn))
    this.store
      .select(selectUser)
      .pipe(
        take(1),
        tap(user => {
          this.user = user
          const businessIds = user?.businessIds
          if (businessIds && businessIds.length) {
            this.businessIdss = businessIds
          }
          this.loadAllBusinesses()
          this.loadAttendances()
        })
      )
      .subscribe()
  }

  ngOnInit(): void {
    this.store.dispatch(clearLatestPunchIn())
    this.form = this.fb.group({
      employeeAttendanceRange: [''],
      fromDate: [''],
      toDate: ['']
    })
    this.totalCount$.subscribe(count => {
      this.totalCount = count
      this.updatePageLastRecord()
    })
    this.store.dispatch(loadEmployeeById({ id: this.employeeId }))
    this.store.dispatch(getLatestClockIn({ id: this.employeeId }))
    this.employee$ = this.store.select(selectEmployeeDetail).pipe(
      map(employee => {
        if (employee) {
          this.employeeData = employee
        }
        return employee
      })
    )
    // this.loadAttendances()

    // this.todaysClockinoutRecords$.subscribe(records => {
    //   this.todaysClockinoutRecords = records

    //   this.progressData = this.calculateProgressBars(this.todaysClockinoutRecords)
    // })

    combineLatest([
      this.todaysClockinoutRecords$,
      this.latestPunchIn$,
      interval(60000).pipe(startWith(0))
    ])
      .pipe(
        map(([records, latestPunchIn]) => {
          const hasOngoing =
            latestPunchIn?.workStatus === this.workstatusEnum.CLOCKIN && !latestPunchIn.clockOut

          let combinedRecords = [...records]

          if (hasOngoing) {
            const existing = records.find(r => r.id === latestPunchIn.id)
            if (!existing) {
              combinedRecords = [...records, latestPunchIn]
            }
          }

          return this.calculateProgressBars(combinedRecords)
        })
      )
      .subscribe(progressData => {
        this.progressData = progressData
      })

    // Subscribe to the observable and log the value of isPunchedIn
    this.isPunchedIn$.subscribe(isPunchedIn => {
      this.isPunchedIn = isPunchedIn
      // console.log('isPunchedIn in constructor: ', isPunchedIn)
    })

    // this.latestPunchIn$.subscribe(latestPunchIn => {
    //   this.latestPunchIn = latestPunchIn
    //   // console.log('latestPunchIn in constructor: ', latestPunchIn?.clockIn)
    //   if (this.latestPunchIn) {
    //     this.latestPunchIn.clockIn = new Date(this.latestPunchIn.clockIn)
    //   }
    // })
    this.latestPunchIn$.subscribe(latestPunchIn => {
      if (latestPunchIn) {
        this.latestPunchIn = {
          ...latestPunchIn,
          clockIn: new Date(latestPunchIn.clockIn)
        }
      } else {
        this.latestPunchIn = null
      }
    })

    this.generateProgress()
    this.updateCircle(this.attendancePercent)

    // Subscribe to totalCount$ safely
    // this.totalWorkHoursThisMonth$.subscribe(count => {
    //   console.log('Month hours from store:', count)
    //   this.totalWorkHoursThisMonth = count // Define this.totalCount in your class
    // })

    // Subscribe to totalCount$ safely
    // this.totalWorkHoursThisWeek$.subscribe(count => {
    //   this.totalWorkHoursThisWeek = count // Define this.totalCount in your class
    // })

    // this.totalWorkHoursToday$.subscribe(count => {
    //   this.totalWorkHoursToday = count // Define this.totalCount in your class
    // })

    // this.totalProductiveWorkHoursToday$.subscribe(count => {
    //   this.totalWorkHoursToday = count // Define this.totalCount in your class
    // })

    // this.totalBreakHoursToday$.subscribe(count => {
    //   this.totalWorkHoursToday = count // Define this.totalCount in your class
    // })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.pickerInitialized) {
        this.initDateRangePicker()
      }
    }, 300)
    this.employee$
      .pipe(
        filter(emp => !!emp),
        take(1)
      )
      .subscribe(() => {
        setTimeout(() => {
          if (!this.pickerInitialized) {
            this.initDateRangePicker()
          }
        }, 0)
      })
  }

  // private initDateRangePicker() {
  //   console.log('initDateRangePicker called')
  //   console.log('element found:', $('#employeeAttendanceDateRange').length)

  //   const formatDate = (date: Date) => {
  //     const d = ('0' + date.getDate()).slice(-2)
  //     const m = ('0' + (date.getMonth() + 1)).slice(-2)
  //     const y = date.getFullYear()
  //     return `${d}/${m}/${y}`
  //   }

  //   const formatApiDate = (date: Date) => {
  //     const d = ('0' + date.getDate()).slice(-2)
  //     const m = ('0' + (date.getMonth() + 1)).slice(-2)
  //     const y = date.getFullYear()
  //     return `${y}-${m}-${d}`
  //   }

  //   const selectedDate = new Date(this.initialDate)
  //   const defaultFormatted = `${formatDate(selectedDate)} - ${formatDate(selectedDate)}`
  //   const defaultFromDate = formatApiDate(selectedDate)
  //   const defaultToDate = formatApiDate(selectedDate)

  //   $('#employeeAttendanceDateRange').daterangepicker({
  //     autoUpdateInput: false,
  //     startDate: selectedDate,
  //     endDate: selectedDate,
  //     locale: { format: 'DD/MM/YYYY' }
  //   })

  //   $('#employeeAttendanceDateRange').val(defaultFormatted)
  //   this.form.patchValue({
  //     employeeAttendanceRange: defaultFormatted,
  //     fromDate: defaultFromDate,
  //     toDate: defaultToDate
  //   })

  //   this.loadAttendancesWithRange(defaultFromDate, defaultToDate)

  //   $('#employeeAttendanceDateRange').on('apply.daterangepicker', (ev: any, picker: any) => {
  //     const formatted =
  //       picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY')
  //     $('#employeeAttendanceDateRange').val(formatted)
  //     const fromDate = picker.startDate.format('YYYY-MM-DD')
  //     const toDate = picker.endDate.format('YYYY-MM-DD')
  //     this.form.patchValue({ employeeAttendanceRange: formatted, fromDate, toDate })
  //     this.loadAttendancesWithRange(fromDate, toDate, true)
  //   })
  // }

  // ngAfterViewInit() {
  //   this.employee$
  //     .pipe(
  //       filter(emp => !!emp),
  //       take(1)
  //     )
  //     .subscribe(() => {
  //       setTimeout(() => this.initDateRangePicker(), 100)
  //     })
  //   setTimeout(() => {
  //     if (!this.pickerInitialized) {
  //       this.initDateRangePicker()
  //     }
  //   }, 800)
  // }

  private initDateRangePicker() {
    if ($('#employeeAttendanceDateRange').length === 0) {
      setTimeout(() => this.initDateRangePicker(), 200)
      return
    }
    if (!this.employeeData || !this.employeeData.joiningDate) {
      setTimeout(() => this.initDateRangePicker(), 200)
      return
    }
    if (this.pickerInitialized) return
    this.pickerInitialized = true
    console.log('initDateRangePicker called')
    const formatDate = (date: Date) => {
      const d = ('0' + date.getDate()).slice(-2)
      const m = ('0' + (date.getMonth() + 1)).slice(-2)
      const y = date.getFullYear()
      return `${d}/${m}/${y}`
    }
    const formatApiDate = (date: Date) => {
      const d = ('0' + date.getDate()).slice(-2)
      const m = ('0' + (date.getMonth() + 1)).slice(-2)
      const y = date.getFullYear()
      return `${y}-${m}-${d}`
    }
    const minAllowedDate = new Date(this.employeeData.joiningDate)
    let selectedDate = new Date(this.initialDate)
    if (selectedDate < minAllowedDate) {
      selectedDate = minAllowedDate
    }
    const defaultFormatted = `${formatDate(selectedDate)} - ${formatDate(selectedDate)}`
    const defaultFromDate = formatApiDate(selectedDate)
    const defaultToDate = formatApiDate(selectedDate)
    const today = new Date()
    $('#employeeAttendanceDateRange').daterangepicker({
      autoUpdateInput: false,
      startDate: selectedDate,
      endDate: selectedDate,
      minDate: minAllowedDate,
      maxDate: today,
      locale: { format: 'DD/MM/YYYY' }
    })
    $('#employeeAttendanceDateRange').val(defaultFormatted)
    this.form.patchValue({
      employeeAttendanceRange: defaultFormatted,
      fromDate: defaultFromDate,
      toDate: defaultToDate
    })
    this.loadAttendancesWithRange(defaultFromDate, defaultToDate)
    $('#employeeAttendanceDateRange').off('apply.daterangepicker')
    $('#employeeAttendanceDateRange').on('apply.daterangepicker', (ev: any, picker: any) => {
      const formatted =
        picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY')
      $('#employeeAttendanceDateRange').val(formatted)
      const fromDate = picker.startDate.format('YYYY-MM-DD')
      const toDate = picker.endDate.format('YYYY-MM-DD')
      this.form.patchValue({ employeeAttendanceRange: formatted, fromDate, toDate })
      this.loadAttendancesWithRange(fromDate, toDate, true)
    })
  }

  loadAttendancesWithRange(fromDate: string, toDate: string, resetPage = false) {
    if (resetPage) {
      this.currentPage = 1
    }
    this.selectedStatus$.next(this.status || null)
    const params: any = {
      // userId: this.employeeId,
      fromDate,
      toDate,
      page: this.currentPage,
      limit: this.pageLimit
    }
    if (this.status) {
      params.workStatus = this.status
    }
    this.store.dispatch(
      loadEmployeeAttendance({
        id: this.employeeId,
        params: new URLSearchParams(params).toString()
      })
    )
  }

  punchIn(): void {
    // this.store.dispatch(createClockInClockOut({ clockIn: new Date() }))
    this.store.dispatch(createClockInClockOut({ clockIn: new Date() }))
    if (this.user) {
      // this.store.dispatch(
      //   loadEmployeeAttendance({
      //     id: this.user.id,
      //     // params: `userId=${this.user.id}`
      //     params: null
      //   })
      // )
      const fromDate = this.form.value.fromDate
      const toDate = this.form.value.toDate

      this.loadAttendancesWithRange(fromDate, toDate)
      this.store.dispatch(getLatestClockIn({ id: this.user.id }))
    }
  }

  punchOut() {
    // if (this.latestPunchIn) {
    //   this.store.dispatch(updateClockIn({ id: this.latestPunchIn.id }))
    // }
    this.latestPunchIn$
      .pipe(
        filter(latestPunchIn => latestPunchIn !== null),
        take(1)
      )
      .subscribe(latestPunchIn => {
        this.store.dispatch(updateClockIn({ id: latestPunchIn.id }))
      })
  }
  liveToday$ = this.createLiveTimer(this.totalWorkHoursToday$)

  liveWeek$ = this.createLiveTimer(this.totalWorkHoursThisWeek$)

  liveMonth$ = this.createLiveTimer(this.totalWorkHoursThisMonth$)
  totalWithBreakToday$ = combineLatest([this.liveToday$, this.totalBreakHoursToday$]).pipe(
    map(([work, breakTime]) => {
      const workMinutes = this.parseTimeToMinutes(work)
      const breakMinutes = this.parseTimeToMinutes(breakTime)

      return this.formatMinutes(workMinutes + breakMinutes)
    })
  )
  private parseTimeToMinutes(time: string | null): number {
    const match = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(time ?? '')
    const hours = match ? parseInt(match[1] || '0', 10) : 0
    const minutes = match ? parseInt(match[2] || '0', 10) : 0
    return hours * 60 + minutes
  }
  private formatMinutes(totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60
    return `${hours}h ${minutes}m`
  }

  private createLiveTimer(baseTime$: Observable<string>) {
    return combineLatest([
      this.latestPunchIn$,
      baseTime$,
      interval(60000).pipe(startWith(0)) // update every minute
    ]).pipe(
      map(([latestPunchIn, totalWorked]) => {
        // 🔹 Convert "0h 17m" → hours number
        const workedMatch = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(totalWorked ?? '')
        const workedHours = workedMatch ? parseInt(workedMatch[1] || '0', 10) : 0
        const workedMinutes = workedMatch ? parseInt(workedMatch[2] || '0', 10) : 0

        let total = workedHours + workedMinutes / 60

        // 🔹 Add running time if currently clocked in
        if (
          latestPunchIn?.clockIn &&
          latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
          !latestPunchIn.clockOut
        ) {
          const clockInTime = new Date(latestPunchIn.clockIn).getTime()
          const now = Date.now()
          const diffInMs = now - clockInTime
          if (diffInMs > 0) {
            const diffInHours = diffInMs / (1000 * 60 * 60)
            total += diffInHours
          }
        }

        // 🔹 Format back to "Xh Ym"
        const hours = Math.floor(total)
        const minutes = Math.floor((total - hours) * 60)

        return `${hours}h ${minutes}m`
      })
    )
  }

  formatTime(totalSeconds: number): string {
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    // const seconds = totalSeconds % 60;

    return `${this.pad(hours)}h ${this.pad(minutes)}m`
  }

  pad(value: number): string {
    return value < 10 ? '0' + value : value.toString()
  }

  loadAttendances() {
    this.selectedStatus$.next(this.status || null)
    const params: any = {}
    // params.userId = this.user?.id
    // params.userId = this.employeeId
    params.page = this.currentPage
    params.limit = this.pageLimit
    // if (this.leaveType ) {
    //   params.leaveType = this.leaveType
    // }
    if (this.status) {
      params.workStatus = this.status
    }
    if (this.dateRange?.startDate && this.dateRange?.endDate) {
      params.fromDate = this.dateRange.startDate.format('YYYY-MM-DD')
      params.toDate = this.dateRange.endDate.format('YYYY-MM-DD')
    }
    // if (this.selectedDate) {
    //   params.fromDate = this.selectedDate
    //   params.toDate = this.selectedDate
    // }
    // this.dateRange = {
    //   startDate: dayjs().startOf('month'),
    //   endDate: dayjs().endOf('month')
    // }
    this.store.dispatch(
      loadEmployeeAttendance({
        // id: this.user?.id,
        id: this.employeeId,
        // params: null
        params: new URLSearchParams(params).toString()
      })
    )
  }

  // onPageChange(newPage: number): void {
  //   if (newPage > 0) {
  //     this.currentPage = newPage
  //     this.loadAttendances() // Reload businesses for the new page
  //     this.updatePageLastRecord()
  //   }
  // }

  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      const fromDate = this.form.value.fromDate
      const toDate = this.form.value.toDate
      if (fromDate && toDate) {
        this.loadAttendancesWithRange(fromDate, toDate)
      } else {
        this.loadAttendances()
      }
      this.updatePageLastRecord()
    }
  }

  // private updatePageLastRecord() {
  //   this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  // }

  private updatePageLastRecord() {
    if (this.totalCount === 0) {
      this.pageLastRecord = 0
      return
    }
    const start = (this.currentPage - 1) * this.pageLimit
    this.pageLastRecord = Math.min(start + this.pageLimit, this.totalCount)
  }

  // onPageLimitChange() {
  //   this.currentPage = 1 // Reset to first page when limit changes
  //   this.loadAttendances() // Load employees with new page limit
  // }

  // onPageLimitChange() {
  //   this.currentPage = 1
  //   const fromDate = this.form.value.fromDate
  //   const toDate = this.form.value.toDate
  //   if (fromDate && toDate) {
  //     this.loadAttendancesWithRange(fromDate, toDate)
  //   } else {
  //     this.loadAttendances()
  //   }
  // }

  onPageLimitChange() {
    this.currentPage = 1
    const fromDate = this.form.value.fromDate
    const toDate = this.form.value.toDate
    if (fromDate && toDate) {
      this.loadAttendancesWithRange(fromDate, toDate)
    } else {
      this.loadAttendances()
    }
    // ✅ Turant update karo — store response aane se pehle bhi sahi dikhe
    this.updatePageLastRecord()
  }

  generateTimeLabels() {
    this.timeLabels = Array.from({ length: 25 }, (_, i) => `${i.toString().padStart(2, '0')}:00`)
  }

  // calculateProgressBars(records: ClockInClockOut[] = []): {
  //   start: string
  //   width: string
  //   color: string
  // }[] {
  //   const progressData: { start: string; width: string; color: string }[] = []

  //   if (!Array.isArray(records) || records.length === 0) {
  //     return progressData
  //   }

  //   // const workingStartIST = 6 * 60 // 6:00 AM IST
  //   // const workingEndIST = 18 * 60 // 6:00 PM IST
  //   const workingStartIST = 0 // 6:00 AM IST
  //   const workingEndIST = 24 * 60 // 6:00 PM IST
  //   // const totalMinutes = workingEndIST - workingStartIST // 720 minutes
  //   const totalMinutes = 1440

  //   // const getMinutesSinceStart = (time: string | Date | null | undefined): number => {
  //   //   if (!time) return 0
  //   //   const date = typeof time === 'string' ? new Date(time) : time
  //   //   return date.getHours() * 60 + date.getMinutes() - workingStartIST
  //   // }

  //   const toIST = (date: Date): Date => {
  //     // Create a new date object shifted by +5:30
  //     return new Date(date.getTime())
  //     // return new Date(date.getTime() + 60 * 60 * 1000)
  //   }

  //   const getMinutesSinceStart = (time: string | Date | null | undefined): number => {
  //     if (!time) return 0
  //     const utcDate = typeof time === 'string' ? new Date(time) : time
  //     const istDate = toIST(utcDate)
  //     // console.log('ist date', istDate)
  //     return istDate.getHours() * 60 + istDate.getMinutes() - workingStartIST
  //   }
  //   // Sort records by clock-in time
  //   // const sortedRecords = [...records].sort(
  //   //   (a, b) => new Date(a.clockIn).getTime() - new Date(b.clockIn).getTime()
  //   // )

  //   // Add "missing time" before first clock-in
  //   const firstIn = records[0].clockIn
  //   const firstInMinutes = getMinutesSinceStart(firstIn)
  //   if (firstInMinutes > 0) {
  //     console.log('first in minutes', firstInMinutes)
  //     progressData.push({
  //       start: '0%',
  //       width: `${(firstInMinutes / totalMinutes) * 100}%`,
  //       color: 'bg-transparent' // or a light grey placeholder
  //     })
  //   }

  //   for (const record of records) {
  //     const inMinutes = getMinutesSinceStart(record.clockIn)
  //     const outMinutes = getMinutesSinceStart(record.clockOut)

  //     const startPercentage = Math.max(0, (inMinutes / totalMinutes) * 100)
  //     const endPercentage = Math.min(100, (outMinutes / totalMinutes) * 100)
  //     const width = Math.max(0, endPercentage - startPercentage)

  //     progressData.push({
  //       start: `${startPercentage.toFixed(2)}%`,
  //       width: `${width.toFixed(2)}%`,
  //       color: this.getWorkStatusColor(record.workStatus)
  //     })
  //   }

  //   return progressData
  // }

  calculateProgressBars(records: ClockInClockOut[] = []): {
    start: string
    width: string
    color: string
  }[] {
    const totalMinutes = 1440 // 24 * 60
    const progressData: { start: string; width: string; color: string }[] = []

    const getMinutes = (time: Date | string): number => {
      const date = new Date(time)
      return date.getHours() * 60 + date.getMinutes()
    }

    const sorted = [...records].sort(
      (a, b) => new Date(a.clockIn).getTime() - new Date(b.clockIn).getTime()
    )

    const first = sorted[0]?.clockIn
    const firstMinutes = getMinutes(first)
    if (firstMinutes > 0) {
      progressData.push({
        start: '0%',
        width: `${(firstMinutes / totalMinutes) * 100}%`,
        color: 'bg-transparent'
      })
    }

    for (const record of sorted) {
      const inMinutes = getMinutes(record.clockIn)
      const outMinutes = record.clockOut ? getMinutes(record.clockOut) : getMinutes(new Date()) // ⏱ use now if not clocked out

      const startPct = Math.max(0, (inMinutes / totalMinutes) * 100)
      const endPct = Math.min(100, (outMinutes / totalMinutes) * 100)
      const width = Math.max(0, endPct - startPct)

      progressData.push({
        start: `${startPct.toFixed(2)}%`,
        width: `${width.toFixed(2)}%`,
        color: this.getWorkStatusColor(record.workStatus || this.workstatusEnum.CLOCKIN)
      })
    }

    return progressData
  }

  getWorkStatusColor(status: string | null) {
    switch (status) {
      case this.workstatusEnum.BREAK:
        return 'bg-warning'
      case this.workstatusEnum.PRESENT:
        return 'bg-success'
      case this.workstatusEnum.CLOCKIN:
        return 'bg-success'
      case 'Uninformed':
        return 'bg-info'
      case 'Overtime':
        return 'bg-secondary'
      default:
        return 'bg-white' // Default color for unknown status
    }
  }

  loadAllBusinesses() {
    const params: any = {}
    if (this.businessIdss?.length) {
      params.businessIds = this.businessIdss.join(',')
    }

    this.store.dispatch(
      loadBusinesses({
        params: new URLSearchParams(params).toString()
      })
    )
  }

  openOffcanvasAttendance(attendance: any) {
    this.selectedAttendance = attendance
  }

  getDashboardRoute(): string {
    // return this.user?.role === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath\
    return eps.employeeDashboardPath
  }

  // readonly totalWorkHoursIncludingCurrent$ = combineLatest([
  //   this.latestPunchIn$,
  //   this.totalWorkHoursToday$,
  //   interval(60000).pipe(startWith(0)) // update every minute
  // ]).pipe(
  //   map(([latestPunchIn, totalWorked]) => {
  //     // Convert "0h 17m" => total hours as number
  //     const workedMatch = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(totalWorked ?? '')
  //     const workedHours = workedMatch ? parseInt(workedMatch[1] || '0', 10) : 0
  //     const workedMinutes = workedMatch ? parseInt(workedMatch[2] || '0', 10) : 0
  //     let total = workedHours + workedMinutes / 60

  //     // Add current ongoing work duration if still clocked in
  //     if (latestPunchIn?.clockIn && latestPunchIn.workStatus === 'ClockIn') {
  //       const clockInTime = new Date(latestPunchIn.clockIn).getTime()
  //       const now = Date.now()
  //       const diffInMs = now - clockInTime
  //       const diffInHours = diffInMs / (1000 * 60 * 60)
  //       total += diffInHours
  //     }

  //     // Format back to "Xh Ym"
  //     const hours = Math.floor(total)
  //     const minutes = Math.round((total - hours) * 60)

  //     return `${hours}h ${minutes}m`
  //   })
  // )

  readonly totalWorkHoursIncludingCurrent$ = combineLatest([
    this.latestPunchIn$,
    this.totalWorkHoursToday$,
    interval(60000).pipe(startWith(0)) // update every minute
  ]).pipe(
    map(([latestPunchIn, totalWorked]) => {
      // Convert "0h 17m" => total hours as number
      const workedMatch = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(totalWorked ?? '')
      const workedHours = workedMatch ? parseInt(workedMatch[1] || '0', 10) : 0
      const workedMinutes = workedMatch ? parseInt(workedMatch[2] || '0', 10) : 0
      let total = workedHours + workedMinutes / 60

      // ✅ Only add if ongoing punch (not finished yet)
      if (
        latestPunchIn?.clockIn &&
        latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
        !latestPunchIn.clockOut
      ) {
        const clockInTime = new Date(latestPunchIn.clockIn).getTime()
        const now = Date.now()
        const diffInMs = now - clockInTime
        if (diffInMs > 0) {
          const diffInHours = diffInMs / (1000 * 60 * 60)
          total += diffInHours
        }
      }

      // ❌ Remove the block that adds finished punches
      // if (latestPunchIn?.clockIn && latestPunchIn.workStatus === 'ClockIn' && !!latestPunchIn.clockOut) {
      //   ...
      // }

      const percent = Math.min((total / this.maxWorkHours) * 100, 100)
      this.updateCircle(percent)

      // Format back to "Xh Ym"
      const hours = Math.floor(total)
      const minutes = Math.round((total - hours) * 60)

      return `${hours}h ${minutes}m`
    })
  )

  generateProgress() {
    const startHour = 9
    const startMinute = 30
    const now = new Date()
    const currentHour = now.getHours()
    const currentMinute = now.getMinutes()
    const startTotal = startHour * 60 + startMinute
    const currentTotal = currentHour * 60 + currentMinute
    const totalMinutes = 24 * 60
    const progress = ((currentTotal - startTotal) / totalMinutes) * 360
    this.progressRotation = `rotate(${progress - 90}deg)`
  }

  updateCircle(value: number) {
    const deg = (value / 100) * 360

    if (value <= 50) {
      this.rightRotation = `rotate(${deg}deg)`
      this.leftRotation = 'rotate(0deg)'
    } else {
      this.rightRotation = 'rotate(180deg)'
      this.leftRotation = `rotate(${deg - 180}deg)`
    }
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Absent':
      case 'Absent First Half':
      case 'Absent Second Half':
      case 'Absent for Half Day':
        return '#FF5252'
      case 'Late':
        return '#FFA500'
      case 'Leave':
      case 'Leave First Half':
      case 'Leave Second Half':
        return '#FFAB40'
      case 'Clock In/Out':
      case 'ClockIn':
        return '#FFBC80'
      case 'Present':
      case 'Present for Half Day':
      case 'Present - Regularized':
        return '#CCFF90'
      case 'Date of Joining':
        return '#1E88E5'
      case 'Early':
        return '#4ECDC4'
      case 'Holiday':
        return '#B39DDB'
      case 'Weekly Off':
        return '#CFB58C'
      default:
        return '#607d8b'
    }
  }

  onStatusChange() {
    this.currentPage = 1
    this.selectedStatus$.next(this.status || null)
    const fromDate = this.form.value.fromDate
    const toDate = this.form.value.toDate
    if (fromDate && toDate) {
      this.loadAttendancesWithRange(fromDate, toDate)
    } else {
      this.loadAttendancesWithRange(this.initialDate, this.initialDate)
    }
  }
}
